import { Button } from '@mui/material';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import MessageLayout from '../component/layout/MessageLayout';

const RegistrationPendingPage: React.FC = () => {
  const navigate = useNavigate();

  const { t } = useTranslation('inactivePage');

  const handleLogout = useCallback(() => {
    navigate('/logout', { replace: true });
  }, [navigate]);

  return (
    <MessageLayout
      title={t('registered')}
      text={t('registeredDetails')}
      actions={
        <Button variant="contained" color="primary" aria-label={t('logout')} onClick={handleLogout} sx={{ paddingX: 4 }}>
          {t('logout')}
        </Button>
      }
    />
  );
};

export default RegistrationPendingPage;
